import moment from 'moment';

/**
 * ACTION PHOTO DOCUMENTS RESERVE INIT
 * Reset reserve photo documents
 */
export const annotationVerificationPhotoDocumentsReserveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RESERVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS RESERVATION
 * Reservation photo documents
 * @param {object} data - data id
 */
export const annotationVerificationPhotoDocumentsReserve = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const authUid = getState().firebase.auth.uid;
    const profileCompany = getState().firebase.profile.company;
    if (
      authUid !== undefined &&
      profileCompany !== undefined &&
      ids !== undefined
    ) {
      dispatch({
        type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RESERVE_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        reserved: true,
        'vinne_verification.user_id': authUid,
        'vinne_verification.start_date': moment().unix(),
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RESERVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RESERVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT SAVE INIT
 * Reset save annotation photo document
 */
export const annotationVerificationPhotoDocumentSaveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT SAVE ANNOTATION
 * Save annotation photo document
 * @param {object} data - data id
 */
export const annotationVerificationPhotoDocumentSave = ({
  id,
  photoTags,
  isChangedPhotoTags = false,
  objects,
  isChangedObjects = false,
  isRejected = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      id !== undefined &&
      photoTags !== undefined &&
      objects !== undefined
    ) {
      dispatch({
        type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: false,
        rejected: isRejected,
        'vinne_verification.verified': true,
        'vinne_verification.end_date': moment().unix(),
        'vinne_verification.photo.human_correction': isChangedPhotoTags,
        'vinne_verification.photo.tags': photoTags,
        'vinne_verification.objects.human_correction': isChangedObjects,
        'vinne_verification.objects.data': objects,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENT FINISH INIT
 * Reset finish annotation photo document
 */
export const annotationVerificationPhotoDocumentFinishInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_FINISH_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT FINISH ANNOTATION
 * Finish annotation photo document
 * @param {object} data - data id
 */
export const annotationVerificationPhotoDocumentFinish = ({
  id,
  photoTags,
  isChangedPhotoTags = false,
  objects,
  isChangedObjects = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (
      profileCompany !== undefined &&
      id !== undefined &&
      photoTags !== undefined &&
      objects !== undefined
    ) {
      dispatch({
        type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_FINISH_PENDING',
      });
      const firestore = getFirebase().firestore();

      const updateObject = {
        reserved: false,
        rejected: false,
        'vinne_verification.verified': true,
        'vinne_verification.end_date': moment().unix(),
        'vinne_verification.photo.human_correction': isChangedPhotoTags,
        'vinne_verification.photo.tags': photoTags,
        'vinne_verification.objects.human_correction': isChangedObjects,
        'vinne_verification.objects.data': objects,
      };

      return await firestore
        .collection('companies')
        .doc(profileCompany.id)
        .collection('photos')
        .doc(id)
        .update(updateObject)
        .then(() => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_FINISH_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_FINISH_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS RELEASE INIT
 * Reset release annotation photo documents
 */
export const annotationVerificationPhotoDocumentsReleaseInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RELEASE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENT RELEASE ANNOTATION
 * Release annotation photo document
 * @param {object} data - data id
 */
export const annotationVerificationPhotoDocumentsRelease = ({ ids }) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && ids !== undefined) {
      dispatch({
        type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RELEASE_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      const updateObject = {
        reserved: false,
      };

      ids.forEach((id) => {
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RELEASE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_RELEASE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};

/**
 * ACTION PHOTO DOCUMENTS SAVE INIT
 * Reset save annotation photo documents
 */
export const annotationVerificationPhotoDocumentsSaveInit = () => {
  return (dispatch) => {
    dispatch({ type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_INIT' });
  };
};

/**
 * ACTION PHOTO DOCUMENTS SAVE ANNOTATION
 * Save annotation photo documents
 * @param {object} data - data id
 */
export const annotationVerificationPhotoDocumentsSave = ({
  data,
  isRejected = false,
}) => {
  return async (dispatch, getState, { getFirebase }) => {
    const profileCompany = getState().firebase.profile.company;
    if (profileCompany !== undefined && data !== undefined) {
      dispatch({
        type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_PENDING',
      });
      const firestore = getFirebase().firestore();
      const batch = firestore.batch();

      data.forEach((photoDocument) => {
        const updateObject = {
          reserved: false,
          rejected: isRejected,
          'vinne_verification.verified': true,
          'vinne_verification.end_date': moment().unix(),
          'vinne_verification.photo.human_correction':
            photoDocument.isChangedPhotoTags,
          'vinne_verification.photo.tags': photoDocument.photoTags,
          'vinne_verification.objects.human_correction':
            photoDocument.isChangedObjects,
          'vinne_verification.objects.data': photoDocument.objects,
        };
        batch.update(
          firestore
            .collection('companies')
            .doc(profileCompany.id)
            .collection('photos')
            .doc(photoDocument.id),
          updateObject
        );
      });

      return await batch
        .commit()
        .then(() => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_SUCCESS',
          });
          return true;
        })
        .catch((err) => {
          dispatch({
            type: 'ANNOTATION_VERIFICATION_PHOTO_DOCUMENT_SAVE_ERROR',
            err,
          });
          return false;
        });
    } else return false;
  };
};
